module.exports = __webpack_public_path__ + "static/img/page3-note.9e4ccb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page3-note.png
// module id = a0xr
// module chunks = 215